import { useMutation } from "@tanstack/react-query";
import { updateSiret } from "../services/users.service";

export const useUpdateSiret = () => {
  return useMutation({
    mutationFn: updateSiret,
  });
};
